import { useCallback } from 'react'

import { DialogWithSubmitContext } from '../../SharedUI/DialogWithSubmitContext'
import { LookupServiceWindow } from './LookupServiceWindow'

export const LookupServiceDialogContainer = ({
  setCustomProps,
  addServiceCallback
}: {
  setCustomProps: (s: boolean) => void
  addServiceCallback?: (serviceIds: string[]) => void
}) => {
  const cancelCallback = useCallback(() => {
    setCustomProps(false)
  }, [setCustomProps])
  const submitCallback = useCallback(
    async (serviceIds: string[]) => {
      if (addServiceCallback) {
        await addServiceCallback(serviceIds)
      }
      setCustomProps(false)
    },
    [addServiceCallback, setCustomProps]
  )
  return (
    <DialogWithSubmitContext
      open={true}
      fullWidth={true}
      maxWidth={'md'}
      onClose={cancelCallback}>
      <LookupServiceWindow
        submitCallback={submitCallback}
        cancelCallback={cancelCallback}
      />
    </DialogWithSubmitContext>
  )
}
